import { render, staticRenderFns } from "./RecipeChangeOwner.vue?vue&type=template&id=3aa333f4&"
import script from "./RecipeChangeOwner.vue?vue&type=script&lang=js&"
export * from "./RecipeChangeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports